export interface UserProfile {
  id: number;
  email: string;
  username: string;
  role: string;
  avatar?: string;
  bio?: string;
  followersCount: number;
  followingCount: number;
  booksCount: number;
}

export interface UserState {
  profile: UserProfile | null;
  loading: boolean;
  error: string | null;
}

const initialState: UserState = {
  profile: null,
  loading: false,
  error: null,
};

const userReducer = (state = initialState, action: any): UserState => {
  switch (action.type) {
    case 'FETCH_PROFILE_START':
      return { ...state, loading: true };
    case 'FETCH_PROFILE_SUCCESS':
      return { ...state, profile: action.payload, loading: false };
    case 'FETCH_PROFILE_FAILURE':
      return { ...state, error: action.payload, loading: false };
    default:
      return state;
  }
};

export default userReducer;
